import React from 'react';
import { SeccionPaciente } from './components/InformePaciente/SeccionPaciente';
import { SeccionUbicacion } from './components/InformePaciente/SeccionUbicacion';
import { SeccionDocumento } from './components/InformePaciente/SeccionDocumento';
import { SeccionProfesional } from './components/InformePaciente/SeccionProfesional';

export const InformePacienteTemplate = ({ data }) => {
    console.log("data", data);

    return (
        <>
            <div style={{ marginTop: '10px', fontSize: '9pt', fontFamily: 'Helvetica' }}>
                <div
                    style={{
                        backgroundColor: '#E0E1E3',
                        boxSizing: 'border-box',
                        padding: '10px',
                        borderRadius: '5px',
                        marginTop: '5px',
                        width: '98%'
                    }}
                >
                    <strong>Número de HC:</strong>&nbsp;{data?.idPaciente}
                </div>
                <br />
                <SeccionPaciente data={data} />
                <br /><br />
                <SeccionUbicacion data={data} />
                <br /><br />
                <table style={{ width: '98%', borderCollapse: 'collapse', border: 'none' }} role='presentation'>
                    <tbody>
                        <tr>
                            <td style={{ width: '43%', padding: '0', verticalAlign: 'top', border: 'none' }}><SeccionDocumento data={data.documentos} /></td>
                            <td style={{ width: '2%', padding: '0', border: 'none' }} />
                            <td style={{ width: '55%', padding: '0', verticalAlign: 'top', border: 'none' }}><SeccionProfesional data={data.profesionales} /></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    )
}